// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"230":"6501d526","490":"b6a8a30e"}[chunkId] + ".css";
};